export default "__VITE_ASSET__6afe893e__"